var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4167 13.125V2.08333H29.1667V7.5L20.8333 0L0 18.75H6.25V35.4167H18.75V22.9167H22.9167V35.4167H35.4167V18.75H41.6667L35.4167 13.125ZM31.25 31.25H27.0833V18.75H14.5833V31.25H10.4167V14.9792L20.8333 5.60417L31.25 14.9792V31.25Z",
    fill: "#FF7D52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8335 14.8333H25.1668C25.1668 12.5417 23.2918 10.6667 21.0002 10.6667C18.7085 10.6667 16.8335 12.5417 16.8335 14.8333Z",
    fill: "#FF7D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.a085c8435dd36cf3520327d1c1d1a00e.svg";
export { ForwardRef as ReactComponent };